import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTCourseTrail from "../../../../../../../../components/_ead/CourseTrail"
import EadRequests from "../../../../../../../../requests/ead-requests"
import moment from "../../../../../../../../helpers/moment"
import MCLoadingOverlay from "../../../../../../../../components/_minha-central/LoadingOverlay"

const SIMULATE_USER_TRACK_ERROR = false
const SIMULATE_SAVE_USER_TRACK_ERROR = false

async function getUserGradeOfModule(userCode, moduleCode) {

    const result = await EadRequests.searchUserForms({
        bestResults: true,
        usrCode: userCode,
        modCode: moduleCode,

    })


    const userForms = result.userform

    const grade = userForms ? userForms.map(f => f.grade * 100.0 / f.value).reduce((total, next) => total + next, 0) / userForms.length : 0

    return isNaN(grade) ? 0 : grade
}

/**
 * Define as notas do módulo
 */
class ModuleGrades {

    grades = {}

    addGrade = (moduleCode, grade) => {
        if (!this.grades[moduleCode]) {
            this.grades[moduleCode] = new UserGrade(0, grade)
        } else {
            this.grades[moduleCode].userGrade = grade
        }
    }

    changeMinPercentageApprovalOfModule = (moduleCode, minPercentageApproval) => {
        if (!this.grades[moduleCode]) {
            this.grades[moduleCode] = new UserGrade(minPercentageApproval)
        } else {
            this.grades[moduleCode].minPercentageApproval = minPercentageApproval
        }
    }


    hasUserBeenApprovedInModule(moduleCode) {
        const moduleGrades = this.grades[moduleCode]
        if (!moduleGrades) return true

        return moduleGrades.hasUserBeenApproved()
    }

    getModuleGrade(moduleCode) {
        return this.grades[moduleCode] || new UserGrade()
    }

}

/**
 * Define se o aluno foi aprovado
 */
class UserGrade {

    userGrade
    minPercentageApproval

    constructor (minPercentageApproval, userGrade = 0) {
        this.userGrade = userGrade
        this.minPercentageApproval = minPercentageApproval
    }

    hasUserBeenApproved = () => {
        return this.userGrade >= this.minPercentageApproval
    }
}

class EadCourseModulesPage extends React.Component {

    state = {
        modules: null,
        tracks: null,
        loading: false,
        moduleGrades: new ModuleGrades()
    }


    componentDidMount() {

        const {
            context,
            release,
            user,
        } = this.props

        return Promise
            .all([
                EadRequests.searchEADModules({
                    prlCode: release.code,
                    eadStatus: 1 // Published
                }),
                EadRequests.searchEadUserTrack({
                    usrCode: user.code,
                    prlCode: release.code
                }),
                SIMULATE_USER_TRACK_ERROR ?
                    Promise.reject('Erro simulado SIMULATE_USER_TRACK_ERROR') : Promise.resolve()
            ])
            .then(results => {
                console.log(results)
                this.setState({
                    modules: results[0],
                    tracks: results[1]
                }, async () => {
                    await this.updateBlockedModulesByGrade()
                })
                this.props.checkContent(this.state.modules)

            })
            .catch(error => {
                console.error(error)
                context.logError(error)

                context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Ocorreu um erro ao carregar o conteúdo do curso.'
                    }
                })
            })
            
    }


    onContentClick = (module, cls, content) => {

        const {
            account,
            release,
            user,
            context
        } = this.props

       

        const req = SIMULATE_SAVE_USER_TRACK_ERROR ?
            Promise.reject('SIMULATE_SAVE_USER_TRACK_ERROR') :
            EadRequests
                .searchEadUserTrack({
                    cntCode: content.code,
                    usrCode: user.code,
                })

        req
            .then(result => {
                // Se nao tem track ainda, cria um novo com status em progresso
                return (result.length === 0) ? {

                    userDTO: user,
                    contentDTO: content,
                    moduleDTO: module,
                    classDTO: cls,
                    startDate: moment(),
                    status: 1 //In progress


                } : null


            })
            .then(userTrack => (!userTrack) ? null : EadRequests.saveUserTrack(userTrack))
            .then(saveResult => {

                if (!saveResult)
                    return null

                if (!saveResult.success) {
                    context.logError(saveResult.errorMessages)

                    context.set({
                        toastMessage: {
                            type: 'error',
                            content: 'Ocorreu um erro ao atualizar os dados de progresso do curso.'
                        }
                    })
                }


            })
            .then(() => this.props.history.push(`/ead/assistir/${account.code}/${user.code}/${release.code}/${content.code}`))
            .catch(error => {

                context.logError(error)

                context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Ocorreu um erro inesperado.'
                    }
                })
            })




    } // Fim onContentClick

    /**
     * Define módulos com o acesso bloqueado
     */
    updateBlockedModulesByGrade = async () => {
        const usrCode = this.props.user.code

        let userApprovedInModule = true
        const { moduleGrades } = this.state
        const cantAccessModuleCodes = []

        for (let m of this.state.modules) {

            if (!userApprovedInModule)
                cantAccessModuleCodes.push(m.code)

            if (!!m.minPercentageApproved) {
                moduleGrades.changeMinPercentageApprovalOfModule(m.code, m.minPercentageApproved)

                const userGrade = await getUserGradeOfModule(usrCode, m.code)

                moduleGrades.addGrade(m.code, userGrade)

                if (!moduleGrades.hasUserBeenApprovedInModule(m.code)) {
                    userApprovedInModule = false
                }

            }
        }


        this.setState({ moduleGrades, cantAccessModuleCodes })

    }

    render() {

        const {modules, tracks, cantAccessModuleCodes} = this.state
        const {user} = this.props
     

        if (!modules || !tracks)
            return <MCLoadingOverlay show={true}/> 

        return (
            <Fragment>
                {
                    !!user &&
                    (
                        <div className={'course-trail'}>
                            {
                            
                                    <NRTCourseTrail
                                    modules={modules}
                                    userTracks={tracks}
                                    onContentClick={this.onContentClick}
                                    cantAccessModuleCodes={this.state.cantAccessModuleCodes}
                                    />
                            }
                        </div>
                    )
                }
               
            </Fragment>
        )
    }
}

EadCourseModulesPage.propTypes = {
    context: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    release: PropTypes.object.isRequired,
}

EadCourseModulesPage.defaultProps = {}


export default EadCourseModulesPage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/CourseModules/index.js